import React from "react";
import "./Iframe.css";

const Iframe = () => {
    return (
        <div className="container iframe-box">
            <iframe src="https://auc.onejp.net/aj_neo?classic" 
            marginHeight="1"
      marginWidth="1"
      scrolling="no"
      allowTransparency="true"
            ></iframe>

        </div>
    );
};

export default Iframe;